import React from 'react';
import { SelectButtonList, SelectButtonItem } from '~/components/SelectButtonList';
import { Vpc } from '~/lib/ApiModel';
import { hasValue } from '~/lib/helper/ArrayHelper';

type NetworkSelectorProps = {
    networks: Vpc[];
    selected: number | undefined;
    onChange: (networkId: number | undefined) => unknown;
};

export default class NetworkSelector extends React.Component<NetworkSelectorProps> {
    render() {
        const { selected, networks, onChange = () => {} } = this.props;
        return (
            <SelectButtonList legend="Network type">
                <SelectButtonItem
                    key={0}
                    isSelected={!hasValue(selected) || selected === 0}
                    onSelect={() => onChange(undefined)}
                >
                    <i className="icon ion-md-globe"></i> Public
                </SelectButtonItem>
                {networks.map((n) => (
                    <SelectButtonItem key={n.id} isSelected={selected === n.id} onSelect={() => onChange(n.id)}>
                        {n.name}
                    </SelectButtonItem>
                ))}
            </SelectButtonList>
        );
    }
}
